import styled, { css } from 'styled-components';

export const Calendar = styled.div(
  ({ theme }) => css`
    border: ${theme.bo.thinWidth} solid ${theme.co.neutral95};
    border-radius: ${theme.bo.mediumSmall};
    width: max-content;
    display: flex;
    flex-direction: ${
      /* istanbul ignore next: tested manually */ theme.rtl ? 'row-reverse' : 'row'
    };
    justify-content: space-between;
  `,
);

export const DayWrapper = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
);

export const DayTitle = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
    color: ${theme.co.secondary20};

    margin-bottom: ${theme.sz.s3};
    border-bottom: ${theme.bo.thinWidth} solid ${theme.co.neutral98};
    width: ${theme.sz.s10};
    height: ${theme.sz.s10};
    align-content: center;
    text-align: center;
  `,
);
